<template>
    <div class="article-collection">
        <div class="article-body">
            <div class="article-body__inner" v-for="article in $globalState.searchResult" :key="article.id">
                <article-card :article="article"></article-card>
            </div>
        </div>
    </div>
</template>

<script>
    import ArticleCard from "../ArticleCard/ArticleCard";
    export default {
        name: "ArticleCollection",
        components: {ArticleCard}
    }
</script>

<style src="./ArticleCollection.scss" lang="scss" scoped />
